import styled, { keyframes, css } from "styled-components";
import { colors } from "healthex-common/colors";
import { FlexColumn, FlexRow } from "./common.styles";
import { SemiBoldText } from "./HXDesktopPage.styles";
import { fontWeights } from "healthex-common/weights";
import { fontSizes } from "healthex-common/sizes";
import { Title } from "./PatientConsentManagerShared.styles";
import Check from "@mui/icons-material/Check";
import { LightText } from "./HXMobilePage.styles";
const fadeIn = keyframes `
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
export const ParentContainer = styled(FlexColumn) `
    width: 100%;
    flex: 1 0 0;
    box-sizing: border-box;
`;
export const MainContainer = styled(FlexColumn) `
    flex: 1 0 0;
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    padding-top: ${(props) => (props.isAnimating && props.animate ? "160px" : "0")};
    transition: padding-top 400ms ease-out;
    transition-delay: 400ms;
    padding-bottom: 24px;
`;
export const ContentContainer = styled(FlexColumn) `
    flex: 1 0 0;
    width: 100%;
    align-self: center;
    gap: ${(props) => { var _a; return (_a = props.gap) !== null && _a !== void 0 ? _a : 40; }}px;
`;
export const HeaderContainer = styled(FlexColumn) `
    gap: 32px;
    flex-shrink: 0;
    align-items: center;
`;
export const ScreenTitle = styled(Title) `
    align-self: center;
    text-align: center;
    font-size: ${fontSizes.MOBILE_TITLE};
    font-weight: ${fontWeights.NORMAL};
    line-height: 36px;
    text-align: ${(props) => { var _a; return (_a = props.textAlign) !== null && _a !== void 0 ? _a : "center"; }};
`;
export const SupportingText = styled(LightText) `
    margin: 0;
    padding: ${(props) => { var _a; return (_a = props.padding) !== null && _a !== void 0 ? _a : "0px 16px"; }};
    opacity: ${(props) => (props.isAnimating === undefined || !props.animate ? 1 : 0)};
    text-align: ${(props) => { var _a; return (_a = props.textAlign) !== null && _a !== void 0 ? _a : "center"; }};

    ${(props) => props.animate &&
    props.isAnimating !== undefined &&
    !props.isAnimating &&
    css `
            animation: ${fadeIn} 400ms ease-in 400ms forwards;
        `}
    white-space: pre-wrap;
`;
export const StepsContainer = styled(FlexColumn) `
    gap: 8px;
    padding: 0 12px;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;

    ${(props) => props.animate &&
    css `
            /* Initial state: always hidden, only animation controls visibility */
            opacity: 0;
        `}

    /* Animation: fade in after heading moves */
    ${(props) => !props.isAnimating &&
    props.animate &&
    css `
            animation: ${fadeIn} 300ms ease-in forwards;
            animation-delay: 500ms;
        `}
`;
export const StepRow = styled(FlexRow) `
    gap: 16px;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
`;
export const StepIconContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    min-width: 36px;
    border-radius: 50%;
    flex-shrink: 0;
    background-color: ${colors.blue_10};
`;
export const StepIcon = styled.img `
    width: 20px;
    height: 20px;
    object-fit: contain;
`;
export const StepTextContainer = styled(FlexColumn) `
    flex: 1;
    align-items: flex-start;
    justify-content: center;
    gap: 2px;
    min-width: 0;
`;
export const StepText = styled(SemiBoldText) `
    color: ${colors.black_light};
    margin: 0;
    padding: 0;
    text-align: left;
    word-wrap: break-word;
    overflow-wrap: break-word;
`;
export const DividerContainer = styled.div `
    display: flex;
    gap: 16px;
    align-items: center;
    padding-right: 28px;
    width: 100%;
    box-sizing: border-box;
`;
export const DividerLineWrapper = styled.div `
    width: 36px;
    height: 20px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;

    &::before {
        content: "";
        width: 2px;
        background-image: repeating-linear-gradient(
            to bottom,
            ${colors.blue_30} 0,
            ${colors.blue_30} 3px,
            transparent 2px,
            transparent 6px
        );
    }
`;
export const DividerLine = styled.div `
    flex: 1;
    height: 1px;
    background-color: ${colors.blue_10};
`;
export const CheckIcon = styled(Check) `
    && {
        color: ${colors.blue_30};
        font-size: 20px;
    }
`;
export const CheckWhiteIcon = styled(Check) `
    && {
        color: ${colors.white_main};
        font-size: 40px;
    }
`;
export const ButtonContainer = styled(FlexColumn) `
    width: 100%;
    align-self: center;
    padding: 24px 0;
    gap: 12px;
    box-sizing: border-box;
    background-color: transparent;
    flex-shrink: 0;

    ${(props) => props.animate &&
    css `
            /* Initial state: always hidden, only animation controls visibility */
            opacity: 0;
        `}

    /* Animation: fade in last */
    ${(props) => !props.isAnimating &&
    props.animate &&
    css `
            animation: ${fadeIn} 300ms ease-in forwards;
            animation-delay: 400ms;
        `}
`;
export const FooterText = styled(LightText) `
    font-size: ${fontSizes.MICRO};
    align-self: stretch;
    text-align: center;
`;
export const Spacer = styled.div `
    width: 100%;
`;
